import React, { useRef, useState } from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Toast from '@stackhouse/dashboard-components/Toast'
import Modal from '@stackhouse/dashboard-components/Modal'
import Button from '@stackhouse/dashboard-components/Button'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Form from '../../components/ResponsiveForm'

const forgotPasswordFields = {
    userEmail: {
        group: 0,
        type: 'text',
        id: 'userEmail',
        label: 'Email',
        email: true,
        required: true,
        autofocus: true,
    },
}


const ForgotPasswordModal = withDashboardContext(({ close, plantDatabase, plantDatabaseField, client, withLoader }) => {

    const formRef = useRef(null)
    const [fields] = useState({
        ...forgotPasswordFields,
        plantDatabase: {
            ...plantDatabaseField,
            value: plantDatabase
        }
    })

    const save = () => {
        if (formRef.current && formRef.current.isValid()) {
            return withLoader(done => {
                return client.post('/User/resetPassword', formRef.current.getValue()).then(() => {
                    setTimeout(Toast.toast({
                        type: 'success',
                        fixed: true,
                        showCloseButton: false,
                        text: `Password has been reset successfully.`,
                    }), 3000)
                }).then(done).then(close).catch(done)
            })
        }
    }

    return (
        <Flex column justifyCenter p={'1em'} backgroundColor={'white'} borderRadius={10}>
            <Flex column>
                <Form ref={formRef} fields={fields} />
            </Flex>
            <Flex row alignCenter justifyEvenly p={10}>
                <Button flex={1} outline title={'Cancel'} onClick={close} />
                <Button flex={1} ml={'1em'} title={'Reset password'} onClick={save} />
            </Flex>
        </Flex>
    )
}, ({ client, withLoader }) => ({ client, withLoader }))


export default ({ plantDatabase, plantDatabaseField }) => {

    return Modal.show(
        ({ close }) => (
            <ForgotPasswordModal close={close} plantDatabase={plantDatabase} plantDatabaseField={plantDatabaseField} />
        ),
        { target: 'root', animation: 'zoom' }
    )
}